/* Open the existing side cart immediately after an item is added. */
document.addEventListener('theme:cart:popdown', function (event) {
  var drawer = document.querySelector('[data-drawer="drawer-cart"]');
  if (!drawer) return;

  event.stopImmediatePropagation();

  fetch(window.theme.routes.cart + '.js')
    .then(function (response) { return response.json(); })
    .then(function (cart) {
      document.dispatchEvent(new CustomEvent('theme:cart:change', {
        detail: { cart: cart },
        bubbles: true
      }));
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open'));
    })
    .catch(function () {
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open'));
    });
}, true);
